/************************************************************************************************************
Author                          : Trizent Technologies Private Limited
Date                            : 
Notes/Remarks                   : 

Organization:  	Trizent Technologies Private Limited.
		Module No. 17, SBC, Thejaswini Building
		Phase 1, Technopark, Thiruvananthapuram - 695581, 
		Kerala, India
 
Copyright 2026 (C) Trizent Technologies Pvt Ltd. (www.trizentinc.com)
All rights reserved.
***************************************************************************************************************/

import React from "react";
import { useTranslation } from 'react-i18next';

interface Props {
  show: boolean;
  onClose: () => void;
  containerProfile: any;
}

const FullLifecycleAuditModal: React.FC<Props> = ({
  show,
  onClose,
  containerProfile,
}) => {
  const { t } = useTranslation();
  
  if (!show) return null;
  return (
          <div className="fixed inset-0 z-[100] flex items-start justify-center pt-24 pl-24 bg-slate-900/40 backdrop-blur-sm animate-in fade-in duration-300">
            <div className="bg-white w-full max-w-5xl max-h-full rounded-[2.5rem] shadow-2xl border border-slate-200 overflow-hidden flex flex-col animate-in zoom-in-95 duration-300">
              <div className="px-10 py-8 border-b border-slate-100 flex items-center justify-between bg-slate-50/50">
                <div className="flex items-center gap-4">
                  <div className="w-12 h-12 rounded-2xl bg-blue-50 text-blue-600 flex items-center justify-center">
                    <span className="material-symbols-outlined text-2xl">{t("containerInventory.icons.history")}</span>
                  </div>
                  <div>
                    <h2 className="text-xl font-black text-[#2D3E50] tracking-tight uppercase">{t("containerInventory.containerLotDetails.auditLog")}</h2>
                    <p className="text-[10px] font-black text-slate-400 uppercase tracking-widest mt-0.5">{t("containerInventory.containerLotDetails.comprehensiveHistory")}: {containerProfile?.serial_number || "-"}</p>
                  </div>
                </div>
                <button 
                  onClick={onClose}
                  className="w-10 h-10 rounded-xl border border-slate-200 flex items-center justify-center text-slate-400 hover:text-red-500 hover:bg-red-50 transition-all"
                >
                  <span className="material-symbols-outlined">{t("containerInventory.icons.close")}</span>
                </button>
              </div>

              <div className="flex-1 overflow-y-auto p-10">
                <div className="bg-white border border-slate-100 rounded-3xl overflow-hidden shadow-sm">
                  <table className="w-full text-left border-collapse">
                    <thead>
                      <tr className="bg-slate-50/50 text-[10px] font-black text-slate-400 uppercase tracking-widest border-b border-slate-100">
                        <th className="px-8 py-5">{t("containerInventory.containerLotDetails.dateandTime")}</th>
                        <th className="px-8 py-5">{t("containerInventory.containerLotDetails.Action")}</th>
                        <th className="px-8 py-5">{t("containerInventory.containerLotDetails.mediaBatch")}</th>
                        <th className="px-8 py-5">{t("containerInventory.containerLotDetails.Operator")}</th>
                        <th className="px-8 py-5">{t("containerInventory.containerLotDetails.Result")}</th>
                      </tr>
                    </thead>
                    <tbody className="divide-y divide-slate-50">
                      {containerProfile?.history_timeline?.map((log: any, i: number) => (
                        <tr key={i} className="hover:bg-slate-50/30 transition-colors">
                          <td className="px-8 py-6">
                            <div className="flex flex-col">
                              <span className="text-xs font-black text-slate-700">
                                {log.event_date?.split(" ")[0]}
                              </span>
                              <span className="text-[10px] font-bold text-slate-400">
                                {log.event_date?.split(" ")[1]}
                              </span>
                            </div>
                          </td>
                          <td className="px-8 py-6">
                            <span className="text-xs font-black text-[#2D3E50]">{log.event_category || "-"}</span>
                          </td>
                          <td className="px-8 py-6">
                            <span
                              className={`text-[10px] font-bold ${
                                log.media_batch ? "text-blue-500" : "text-slate-300"
                              }`}
                            >
                              {log.media_batch || "N/A"}
                            </span>
                          </td>
                          <td className="px-8 py-6">
                            <div className="flex items-center gap-2">
                              <div className="w-5 h-5 rounded-full bg-slate-100 flex items-center justify-center text-[10px] text-slate-400">
                                <span className="material-symbols-outlined text-xs">{t("containerInventory.icons.person")}</span>
                              </div>
                              <span className="text-[10px] font-black text-slate-500 uppercase">{log.performed_by || "-"}</span>
                            </div>
                          </td>
                          <td className="px-8 py-6">
                            <span className="text-[10px] font-bold text-slate-500 italic">{log.result}</span>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>

              <div className="px-10 py-6 border-t border-slate-100 bg-slate-50/50 flex justify-between items-center text-[9px] font-black text-slate-400 uppercase tracking-widest">
                {/* <span>Total Audit Entries: {fullLogs.length}</span> */}
                {/* <button 
                  onClick={() => window.print()}
                  className="flex items-center gap-2 text-blue-600 hover:text-blue-700 transition-colors"
                >
                  <span className="material-symbols-outlined text-lg">download</span>
                  Export Audit Report
                </button> */}
              </div>
            </div>
          </div>
)}


export default FullLifecycleAuditModal;